import styles from './Toggle.module.scss';

const Toggle = ({
  isActive,
  handleClick,
  isDisabled,
  children,
}: {
  isActive: boolean;
  handleClick?: (currentState: boolean) => void;
  isDisabled?: boolean;
  children?: React.ReactNode;
}) => {
  return (
    <label className={styles.wrapper}>
      <input
        type="checkbox"
        checked={isActive}
        onChange={() => handleClick && handleClick(!isActive)}
        onKeyUp={(e) => {
          if (e.key === 'Enter' && handleClick) {
            handleClick(!isActive);
          }
        }}
        disabled={isDisabled}
      />
      <span className={styles.toggle}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="18"
          viewBox="0 0 28 18"
          fill="none"
        >
          <rect
            className={styles['toggle-rect']}
            x=".5"
            y=".5"
            width="27"
            height="17"
            rx="8.5"
          />
          <circle className={styles['toggle-circle']} cx={'9'} cy="9" r="6" />
        </svg>
      </span>
      {children}
    </label>
  );
};

export default Toggle;
